/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../Container/Container";
import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import HeadlineSection from "../Sections/Generic/HeadlineSection/HeadlineSection";
import jobsImage from "../../assets/img/jobs/Jobs_people.svg";
import wayWeWorkSectionStyle from "./wayWeWorkSectionStyle";

const WayWeWorkSection = () => {
  return (
    <Container sx={wayWeWorkSectionStyle.container}>
      <HeadlineSection headline={"Wie wir arbeiten"} typographyVariant={"h1"} typographyComponent={"h3"} image={jobsImage} />
      <Grid
        container
        sx={{
          justifyContent: "space-around",
        }}
      >
        <Paper component={Grid} elevation={0} sx={wayWeWorkSectionStyle.item}>
          mit neuester Technologie am Thema Recht
        </Paper>
        <Paper component={Grid} elevation={0} sx={wayWeWorkSectionStyle.item}>
          immer die Mandantschaft im Fokus
        </Paper>
        <Paper component={Grid} elevation={0} sx={wayWeWorkSectionStyle.item}>
          persönlich und mit viel Spaß
        </Paper>
        <Paper component={Grid} elevation={0} sx={wayWeWorkSectionStyle.item}>
          mit flexiblen Arbeitszeiten, ob im Büro oder von Zuhause
        </Paper>
        <Paper component={Grid} elevation={0} sx={wayWeWorkSectionStyle.item}>
          mit fantastischem Blick in unserem Büro direkt am Rhein
        </Paper>
        <Paper component={Grid} elevation={0} sx={wayWeWorkSectionStyle.item}>
          hochmotiviert
        </Paper>
      </Grid>
    </Container>
  );
};

export default WayWeWorkSection;
